var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCommentCheck = function SvgCommentCheck(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#5CDBD3",
    fillOpacity: 0.18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2 4.5H14.8C15.46 4.5 16 5.04 16 5.7V15.2929C16 15.7383 15.4614 15.9614 15.1464 15.6464L13.8929 14.3929C13.7054 14.2054 13.451 14.1 13.1858 14.1H5.2C4.54 14.1 4 13.56 4 12.9V5.7C4 5.04 4.54 4.5 5.2 4.5ZM13.1381 8.13807C13.3984 7.87772 13.3984 7.45561 13.1381 7.19526C12.8777 6.93491 12.4556 6.93491 12.1953 7.19526L9.66667 9.72386L8.13807 8.19526C7.87772 7.93491 7.45561 7.93491 7.19526 8.19526C6.93491 8.45561 6.93491 8.87772 7.19526 9.13807L9.19526 11.1381C9.45561 11.3984 9.87772 11.3984 10.1381 11.1381L13.1381 8.13807Z",
    fill: "#5CDBD3"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCommentCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "comment-check.937cf38581a40065d7051871bfcf9d19.svg";